module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/subscription-product/subscription-product.component.scss
// module id = ./src/app/admin/subscription-product/subscription-product.component.scss
// module chunks = main